import Icon from "@ant-design/icons";
import type { CustomIconComponentProps } from "@ant-design/icons/lib/components/Icon";

const IconSvg = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8 0.75C6.56609 0.75 5.16437 1.1752 3.97212 1.97185C2.77986 2.76849 1.85061 3.90078 1.30188 5.22554C0.753141 6.55031 0.609567 8.00804 0.88931 9.4144C1.16905 10.8208 1.85955 12.1126 2.87348 13.1265C3.88741 14.1405 5.17923 14.8309 6.5856 15.1107C7.99196 15.3904 9.44969 15.2469 10.7745 14.6981C12.0992 14.1494 13.2315 13.2201 14.0282 12.0279C14.8248 10.8356 15.25 9.43391 15.25 8C15.2479 6.07782 14.4834 4.23496 13.1242 2.87577C11.765 1.51658 9.92218 0.752079 8 0.75ZM8 14.0417C6.80507 14.0417 5.63698 13.6873 4.64343 13.0235C3.64988 12.3596 2.87551 11.416 2.41823 10.312C1.96095 9.20807 1.84131 7.9933 2.07443 6.82133C2.30754 5.64936 2.88296 4.57284 3.7279 3.7279C4.57284 2.88295 5.64936 2.30754 6.82133 2.07442C7.9933 1.8413 9.20808 1.96095 10.312 2.41823C11.416 2.87551 12.3596 3.64988 13.0235 4.64343C13.6873 5.63698 14.0417 6.80507 14.0417 8C14.0399 9.60181 13.4028 11.1375 12.2702 12.2702C11.1375 13.4028 9.60181 14.0399 8 14.0417Z"
      fill="#151718"
    />
    <path
      d="M8 6.79166H7.39583C7.2356 6.79166 7.08192 6.85532 6.96862 6.96862C6.85532 7.08192 6.79166 7.2356 6.79166 7.39583C6.79166 7.55607 6.85532 7.70974 6.96862 7.82304C7.08192 7.93634 7.2356 8 7.39583 8H8V11.625C8 11.7852 8.06365 11.9389 8.17695 12.0522C8.29026 12.1655 8.44393 12.2292 8.60416 12.2292C8.7644 12.2292 8.91807 12.1655 9.03137 12.0522C9.14468 11.9389 9.20833 11.7852 9.20833 11.625V8C9.20833 7.67953 9.08102 7.37218 8.85442 7.14558C8.62781 6.91897 8.32047 6.79166 8 6.79166Z"
      fill="#151718"
    />
    <path
      d="M8 5.58333C8.5005 5.58333 8.90625 5.17759 8.90625 4.67708C8.90625 4.17657 8.5005 3.77083 8 3.77083C7.49949 3.77083 7.09375 4.17657 7.09375 4.67708C7.09375 5.17759 7.49949 5.58333 8 5.58333Z"
      fill="#151718"
    />
  </svg>
);

const InfoIconOutlined = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={IconSvg} {...props} />
);

export default InfoIconOutlined;
